// GeoJSON cache using Cache API (works in production with Cloudflare)
const CACHE_NAME = 'mymap-geojson-v1';

export async function fetchGeoJSON(url: string, etag?: string): Promise<{ data: any; etag: string | null }> {
  const cache = await caches.open(CACHE_NAME);
  const cached = await cache.match(url);

  const headers: HeadersInit = {};
  if (etag) headers['If-None-Match'] = etag;

  const res = await fetch(url, { headers });

  if (res.status === 304 && cached) {
    const data = await cached.json();
    return { data, etag: etag ?? null };
  }

  if (!res.ok) {
    throw new Error(`Failed to fetch GeoJSON: ${res.status}`);
  }

  const data = await res.json();
  const newEtag = res.headers.get('ETag') ?? null;
  await cache.put(url, new Response(JSON.stringify(data), {
    headers: { 'Content-Type': 'application/geo+json', ...(newEtag ? { ETag: newEtag } : {}) },
  }));
  return { data, etag: newEtag };
}

export async function clearGeoJSONCache(): Promise<void> {
  await caches.delete(CACHE_NAME);
}
